import Button from 'components/UI/Button/Button';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import Modal from 'components/UI/Modal/Modal';
import { usePermission } from 'hooks/usePermission';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import './SettingsModal.module.scss';

export default function SettingsModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { theme, rootProject, handlePublication } = useContext(
    ProjectDetailsContext
  );

  const userId = useRedux((state) => state.authentication?.user?.id);

  const [isChecked, setIsChecked] = useState(!!rootProject?.is_public);

  function handleClick() {
    handlePublication({ processIsChecked: isChecked });
    setModalIsOpen(false);
  }

  const translate = useTranslate();

  const isMyTheme = theme?.created_by === userId;
  const isStudent = usePermission(['Leerling', 'Leerling Portfolio']);

  return (
    <Modal setModalIsOpen={setModalIsOpen} size="medium">
      <div styleName="modalContent2">
        <div styleName="image-wrapper">
          <img src="/images/laptop.svg" alt="laptop" />
        </div>
        <h1>{translate('project.publication-popups.publication-settings')}</h1>
        {!isStudent && (
          <p>
            {translate('project.publication-popups.text-01')}
            <br />
            {translate('general.terms.more-info')}{' '}
            <NavLink to="/bibliotheek/groowtorials">
              {translate(
                'project.publication-popups.view-sharecode-groowtorial'
              )}
            </NavLink>
          </p>
        )}
        {isMyTheme && (
          <p>
            {translate('project.publication-popups.adjust-theme')}
            <br />
            {translate('project.publication-popups.adjust-theme2')}
            <a href="mailto:groow@studiotast.com?">
              {' '}
              {translate('project.publication-popups.adjust-theme-link')}
            </a>
          </p>
        )}
        <p>
          <b>{translate('project.publication-popups.share-process')}</b>
          <br />
          {translate('project.publication-popups.text-05')}
          <br />
          {translate('project.publication-popups.text-06')}
          <br />
          {translate('project.publication-popups.text-07')}
          <br />
          {translate('project.publication-popups.confirm')}
          <br />
        </p>
        <Checkbox isChecked={isChecked} setIsChecked={setIsChecked}>
          {translate('project.publication-popups.publish-process')}
        </Checkbox>
        <div styleName="buttons-wrapper">
          <Button onClick={() => setModalIsOpen(false)} color="grey">
            {translate('general.terms.cancel')}
          </Button>
          <Button
            onClick={handleClick}
            inactive={isChecked === !!rootProject?.is_public}
          >
            {translate('general.terms.edit')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
